import { apiClient } from "./apiClient";
import { IHocSinhSelectAllRequest } from "../models/request/hoc-sinh/IHocSinhSelectAllRequest";
import { IHocSinhImportRequest } from "../models/request/hoc-sinh/IHocSinhImportRequest";
import { IHocSinhUpdateStatusRequest } from "../models/request/hoc-sinh/IHocSinhUpdateStatusRequest";
import { IHocSinhNgayNhapHocRequest } from "./../models/request/hoc-sinh/IHocSinhNgayNhapHocRequest";
import { IHocSinhSelectRequest } from "../models/request/hoc-sinh/IHocSinhSelectRequest";
import { HocSinhFormSubmitRequest } from "../models/request/hoc-sinh/HocSinhFormSubmitRequest";
import { IStudentBaseInformation } from "../models/request/acceptance-form/IStudentBaseInformation";
import { apiGuestClient } from "./apiGuestClient";
import { HocSinhDoiTrangThaiRequest } from "../models/request/hoc-sinh/HocSinhDoiTrangThaiRequest ";

// API Endpoints
export const HOC_SINH_API_END_POINT = "hoc-sinh";
export const HOC_SINH_API_SELECT_END_POINT = "hoc-sinh/select";

export const crmHocSinhApi = {
  select: (request: IHocSinhSelectRequest) =>
    apiClient.post(`${HOC_SINH_API_END_POINT}/select`, request),
  select_all_hocsinh: (request: IHocSinhSelectRequest) =>
    apiClient.post(`${HOC_SINH_API_END_POINT}/select_all_hocsinh`, request),
  update: (data: HocSinhFormSubmitRequest) =>
    apiClient.put(`${HOC_SINH_API_END_POINT}`, data),

  getById: (id: number, namHoc: string) =>
    apiClient.get(`${HOC_SINH_API_END_POINT}/${id}/nam-hoc/${namHoc}`),
  getHSCCById: (id: number, namHoc: string) =>
    apiClient.get(`hocsinh-chuyencap/${id}/nam-hoc/${namHoc}`),
  getAllHSCCById: (id: number) =>
    apiClient.get(`hocsinh-chuyencap/all/${id}`),
  getHSCLById: (id: number, namHoc: string) =>
    apiClient.get(`hocsinh-chuyenlop/${id}/nam-hoc/${namHoc}`),
  getAllHSCLById: (id: number) =>
    apiClient.get(`hocsinh-chuyenlop/all/${id}`),

  insert: (data: any) => apiClient.post(`${HOC_SINH_API_END_POINT}`, data),

  delete: (id: number) => apiClient.delete(`${HOC_SINH_API_END_POINT}/${id}`),

  // Status and approval operations
  approve: (data: any) =>
    apiClient.post(`${HOC_SINH_API_END_POINT}/approve`, data),
  updateAcceptanceForm: (request: IStudentBaseInformation) => {
    // Convert ngay_sinh string to timestamp to match backend expectation
    const formatDateToTimestamp = (dateString: string | undefined): number => {
      if (!dateString) return 0;
      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return 0;
        return date.getTime();
      } catch {
        return 0;
      }
    };

    // Transform the request to match HocSinhFormSubmitRequest interface
    const transformedRequest = {
      ...request,
      ngay_sinh_timestamp: formatDateToTimestamp(request.ngay_sinh)
    };

    return apiGuestClient.put(`${HOC_SINH_API_END_POINT}/acceptance-form`, transformedRequest);
  },

  updateStatus: (request: IHocSinhUpdateStatusRequest) =>
    apiClient.put(`${HOC_SINH_API_END_POINT}/status`, request),

  updateNgayNhapHoc: (request: IHocSinhNgayNhapHocRequest) =>
    apiClient.put(`${HOC_SINH_API_END_POINT}/ngay-nhap-hoc`, request),

  // Search and select operations
  search: (dm_truong_id: number, key: string) =>
    apiClient.get(
      `${HOC_SINH_API_END_POINT}/search/truong/${dm_truong_id}/key/${encodeURIComponent(
        key
      )}`
    ),

  selectByParent: (ts_phuhuynh_id: number) =>
    apiClient.get(`phu-huynh/${ts_phuhuynh_id}/hoc-sinh`),

  selectParents: (data: any) =>
    apiClient.post(`${HOC_SINH_API_END_POINT}/phu-huynh/select`, data),

  selectToExport: (data: any) =>
    apiClient.post(`${HOC_SINH_API_END_POINT}/select-export`, data),

  selectSuggestEmail: (ts_hocsinh_id: number) =>
    apiClient.get(
      `${HOC_SINH_API_END_POINT}/select_suggest_email/${ts_hocsinh_id}`
    ),

  selectByMaHs: (ma_hs: string, dm_coso_id: number = 1) =>
    apiClient.get(`${HOC_SINH_API_END_POINT}/ma/${ma_hs}/co-so/${dm_coso_id}`),

  selectByMaTn: (ma_tn: string, dm_coso_id: number = 1) =>
    apiClient.get(`${HOC_SINH_API_END_POINT}/ma-tn/${ma_tn}/co-so/${dm_coso_id}`),

  selectPhuHuynh: (id: number, dm_quanhe_id: number) =>
    apiClient.get(`${HOC_SINH_API_END_POINT}/id/${id}/quanhe/${dm_quanhe_id}`),

  generateStudentCode: (dm_coso_id: number) =>
    apiClient.get(`${HOC_SINH_API_END_POINT}/generate-code/${dm_coso_id}`),

  generateMaHs: (dm_coso_id: number, dm_truong_id: number = 0) =>
    apiClient.get(`${HOC_SINH_API_END_POINT}/generate-ma-hs/${dm_coso_id}?dm_truong_id=${dm_truong_id}`),

  // Import operations
  import: ({ data, nam_hoc, dm_coso_id = 0 }: IHocSinhImportRequest) =>
    apiClient.put(
      `${HOC_SINH_API_END_POINT}/import/nam-hoc/${nam_hoc}/co-so/${dm_coso_id}`,
      data
    ),

  validateImport: ({ data, nam_hoc, dm_coso_id = 0 }: IHocSinhImportRequest) =>
    apiClient.put(
      `${HOC_SINH_API_END_POINT}/validate-import/nam-hoc/${nam_hoc}/co-so/${dm_coso_id}`,
      data
    ),

  importLenLop: ({ data, nam_hoc, dm_coso_id = 0 }: IHocSinhImportRequest) =>
    apiClient.put(
      `${HOC_SINH_API_END_POINT}/import-len-lop/nam-hoc/${nam_hoc}/co-so/${dm_coso_id}`,
      data
    ),

  validateImportLenLop: ({
    data,
    nam_hoc,
    dm_coso_id = 0,
  }: IHocSinhImportRequest) =>
    apiClient.put(
      `${HOC_SINH_API_END_POINT}/validate-import-len-lop/nam-hoc/${nam_hoc}/co-so/${dm_coso_id}`,
      data
    ),

  // Special operations
  selectNotInAceChiTiet: (data: any) =>
    apiClient.post(
      `${HOC_SINH_API_END_POINT}/select_not_in_ace_chi_tiet`,
      data
    ),

  selectAceById: (data: any) =>
    apiClient.post(`${HOC_SINH_API_END_POINT}/select_ace_by_id`, data),

  SelectTongHopAce: (request: IHocSinhSelectRequest) =>
    apiClient.post(`${HOC_SINH_API_END_POINT}/select-all-list-ace`, request),

  SelectTongHopCbnv: (request: IHocSinhSelectRequest) =>
    apiClient.post(`${HOC_SINH_API_END_POINT}/select-all-list-cbnv`, request),
  SelectTongHopBdca: (request: IHocSinhSelectRequest) =>
    apiClient.post(`${HOC_SINH_API_END_POINT}/select-all-list-bdca`, request),

  SelectTongHopGiayTo: (request: IHocSinhSelectRequest) =>
    apiClient.post(`${HOC_SINH_API_END_POINT}/select-all-list-giayto`, request),

  SelectTongHopSucKhoe: (request: IHocSinhSelectRequest) =>
    apiClient.post(`${HOC_SINH_API_END_POINT}/select-all-list-suckhoe`, request),

  ExportTongHopGiayTo: (request: { hocsinh_ids: number[], nam_hoc: string, dm_coso_id: number }) =>
    apiClient.post(`${HOC_SINH_API_END_POINT}/export-tong-hop-giay-to`, request),

  ExportTongHopGiayToHtml: (request: { hocsinh_ids: number[], nam_hoc: string, dm_coso_id: number }) =>
    apiClient.post(`${HOC_SINH_API_END_POINT}/export-tong-hop-giay-to/html`, request),

  ExportBanGiaoHoSoHtml: (request: { hocsinh_ids: number[], nam_hoc: string, dm_coso_id: number }) =>
    apiClient.post(`${HOC_SINH_API_END_POINT}/export-ban-giao-ho-so/html`, request),

  DoiTrangThai: (request: HocSinhDoiTrangThaiRequest) =>
    apiClient.post(`${HOC_SINH_API_END_POINT}/doi-trang-thai`, request),

  checkDuplicate: (request: { searchText: string; dm_coso_id: number }) =>
    apiClient.post(`${HOC_SINH_API_END_POINT}/search`, {
      dm_coso_id: request.dm_coso_id || 1,
      key: request.searchText,
    }),

  // Lịch sử đổi mã
  getLichSuDoiMa: (ts_hocsinh_id: number) =>
    apiClient.get(`lich-su-doi-ma/hoc-sinh/${ts_hocsinh_id}`),
};
